<template>
  <footer>
    <div class="container-fluid footer-top footer-payment">
      <div class="container container-boxed-layout">
        <div class="payment-logo-holder" v-if="$store.state.loggedIn && $root.dueBills !== null && $root.dueBills.amount > 0">
          <div class="row image-holder simplepay-holderrow">
            <div class="col">
              <a class="payment-link" href="http://simplepartner.hu/PaymentService/Fizetesi_tajekoztato.pdf" target="_blank">
                <img class="payment-logo" id="simple" src="@/assets/img/payment/simplepay_otp_hu_top_cropped.png" />
              </a>
            </div>
          </div>
          <div class="row image-holder paymentlogo-holderrow">
            <div class="col col-md-4">
              <img class="payment-logo" src="@/assets/img/payment/Maestro.png" />
              <img class="payment-logo" src="@/assets/img/payment/MasterCard.png" />
            </div>
            <div class="col col-md-8">
              <img class="payment-logo" src="@/assets/img/payment/VISA.png" id="visa" />
              <img class="payment-logo" src="@/assets/img/payment/VISA_electron.png" />
              <img class="payment-logo" src="@/assets/img/payment/American_Express.png" />
            </div>
          </div>
          <div class="row image-holder">
            <div class="col">
              <a class="payment-link" href="https://www.paymentgateway.hu/" target="_blank">
                <img class="payment-logo" id="bigfish" src="@/assets/img/payment/bf_pmgw_2-small_transparent.png" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container-fluid footer-top">
      <div class="container container-boxed-layout">
        <div class="row no-padding">
          <div class="col col-12 col-md-4">
            <a class="navbar-brand" href="javascript:void(0);">
              <img src="@/assets/img/genertel-logo.svg" alt="Genertel" />
            </a>
            <a class="navbar-brand blog-logo" target="_blank" :href="content.get('blogUrl')">
              <img src="@/assets/img/genertel_blog.png" />
            </a>
          </div>
          <div class="col col-6 col-sm-3 col-md-2">
            <a class="h6 footer-col-heading collapsed" data-toggle="collapse" href="#multiCollapseCol1" role="button" aria-expanded="false" aria-controls="multiCollapseCol1">{{ content.get('insurancesTitle') }}</a>
            <div class="collapse multi-collapse" id="multiCollapseCol1">

            <ul>
              <li>
                <a :href="content.get('insuranceLink1Url')" target="_blank">
                  {{
                  content.get('insuranceLink1Name')
                  }}
                </a>
              </li>
              <li>
                <a :href="content.get('insuranceLink2Url')" target="_blank">{{ content.get('insuranceLink2Name') }}</a>
              </li>
              <li>
                <a :href="content.get('insuranceLink3Url')" target="_blank">
                  {{
                  content.get('insuranceLink3Name')
                  }}
                </a>
              </li>
              <li>
                <a :href="content.get('insuranceLink4Url')" target="_blank">
                  {{
                  content.get('insuranceLink4Name')
                  }}
                </a>
              </li>
              <li>
                <a :href="content.get('insuranceLink5Url')" target="_blank">{{ content.get('insuranceLink5Name') }}</a>
              </li>
              <li>
                <a :href="content.get('insuranceLink6Url')" target="_blank">
                  {{
                  content.get('insuranceLink6Name')
                  }}
                </a>
              </li>
              <li>
                <a :href="content.get('insuranceLink7Url')" target="_blank">
                  {{
                  content.get('insuranceLink7Name')
                  }}
                </a>
              </li>
              <li>
                <a :href="content.get('insuranceLink8Url')" target="_blank">
                  {{
                  content.get('insuranceLink8Name')
                  }}
                </a>
              </li>
            </ul>
        </div>
          </div>
          <div class="col col-6 col-sm-3 col-md-2">
            <a class="h6 footer-col-heading collapsed" data-toggle="collapse" href="#multiCollapseCol2" role="button" aria-expanded="false" aria-controls="multiCollapseCol2">{{ content.get('statements') }}</a>
            <div class="collapse multi-collapse" id="multiCollapseCol2">
            <ul>
              <li>
                <a :href="content.get('legalStatementUrl')" target="_blank">
                  {{
                  content.get('legalStatement')
                  }}
                </a>
              </li>
              <li>
                <a :href="content.get('privacyPolicyUrl')" target="_blank">
                  {{
                  content.get('privacyPolicy')
                  }}
                </a>
              </li>
            </ul>
            </div>
          </div>
          <div class="col col-6 col-sm-3 col-md-2">
            <a class="h6 footer-col-heading collapsed" data-toggle="collapse" href="#multiCollapseCol3" role="button" aria-expanded="false" aria-controls="multiCollapseCol3">{{ content.get('genertel') }}</a>
            <div class="collapse multi-collapse" id="multiCollapseCol3">
            <ul>
              <li>
                <a :href="content.get('aboutUrl')" target="_blank">{{ content.get('about') }}</a>
              </li>
              <li>
                <a :href="content.get('carrierUrl')" target="_blank">{{ content.get('carrier') }}</a>
              </li>
            </ul>
            </div>
          </div>
          <div class="col col-6 col-sm-3 col-md-2">
            <a class="h6 footer-col-heading collapsed" data-toggle="collapse" href="#multiCollapseCol4" role="button" aria-expanded="false" aria-controls="multiCollapseCol4">{{ content.get('contact') }}</a>
            <div class="collapse multi-collapse" id="multiCollapseCol4">
            <ul>
              <li>
                <a :href="content.get('customerServiceUrl')" target="_blank">
                  {{
                  content.get('customerService')
                  }}
                </a>
              </li>
              <li>
                <a :href="content.get('faqUrl')" target="_blank">{{ content.get('faq') }}</a>
              </li>
              <li>
                <a :href="'/'" @click="openModal">{{ content.get('contactUs') }}</a>
                
                <div class="modal fade" id="contactNavigationModal" tabindex="-1" role="dialog" aria-hidden="true">
                  <div class="modal-dialog modal-dialog-centered" role="document">
                    <div class="modal-content">
                      <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                      </button>
                      <div class="wh-set">
                        <div class="modal-header">
                          <h5 class="modal-title">{{ content.get('title') }}</h5>
                        </div>
                        <div class="modal-body">
                          {{ content.get('hint') }}
                        </div>
                        <div class="modal-footer">
                          <div class="row justify-space-between">
                            <button type="button"
                              class="btn btn-filled btn-w10rem"
                              @click="redirectTo(content.get('urlForClient'))"
                            >
                              <span style="color: white">
                                {{ content.get('clientButton') }}
                              </span>
                            </button>

                            <button type="button"
                              class="btn btn-outline btn-w12rem"
                              @click="redirectToWWWFrontend(content.get('urlForNewcomer'))"
                            >
                              <span style="color: #4E95FB">
                                {{ content.get('newcomerButton') }}
                              </span>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>


              </li>
            </ul>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="container-fluid footer-bottom">
      <div class="container container-boxed-layout">
        <div class="copyright flex-grow-1 d-inline-flex">
          <p>{{ content.get('copyright') + new Date().getFullYear() }}</p>
        </div>
        <div class="footer-menu flex-grow-1 d-inline-flex text-right">
          <ul class="navbar-nav main-menu">
            <li class="nav-item">
              <a :href="content.get('siteMapUrl')">
                <div class="menu-text">{{ content.get('siteMap') }}</div>
              </a>
            </li>
            <li class="nav-item">
              <a :href="content.get('imprintUrl')">
                <div class="menu-text">{{ content.get('imprint') }}</div>
              </a>
            </li>
            <li class="nav-item">
              <a :href="content.get('privacyStatementUrl')">
                <div class="menu-text">{{ content.get('privacyStatement') }}</div>
              </a>
            </li>
            <li class="nav-item">
              <a :href="content.get('legalStatementUrl')">
                <div class="menu-text">{{ content.get('legalStatement') }}</div>
              </a>
            </li>
          </ul>
          <a class="facebook-button">
            <i class="fab fa-facebook-f"></i>
          </a>
        </div>
      </div>
    </div>
  </footer>
</template>
<script>
import "vuetify";
import "vuetify/dist/vuetify.min.css";

import ContentMixin from "../mixins/ContentMixin";
import Vue from "vue";
import VueAnalytics from "vue-analytics";
import store from "../store";


export default {
  mixins: [ContentMixin],
  created: function() {
    this.loadContent("footer");
    this.loadContent("modal/kontakt-navigacio");
  },
  methods: {
    openModal(e) {
      e.preventDefault();
      if (store.state.loggedIn)
      {
        this.redirectTo("/ugyintezes");
        return;
      }

      $("#contactNavigationModal").modal({
          fadeDuration: 100,
      });
    },
    redirectTo(target) {
      window.location.href = target;
    },
    redirectToWWWFrontend(target) {
      this.redirectTo(this.composeWWWFrontendUrl(target));
    },
  }
};
</script>
